import { getToken } from '@/utils/auth'
import { getItem } from '@/utils/storage'

export const state = () => ({
  isAuth: !!getToken(), // ✅ Token bor yoki yo‘qligini tekshiramiz
  user: getItem("user") || null,
  role: getItem("user") ? getItem("user").role : "",
  defaultRegion: getItem("user")?.rights?.["stat2.it-park.uz"]?.region_ids?.length ? getItem("user")?.rights?.['stat2.it-park.uz']?.region_ids?.length == 15 ? null : getItem("user")?.rights?.["stat2.it-park.uz"]?.region_ids[0] : null
})
